import { ExpenseAttributes } from "@albatrosdeveloper/ave-models-package";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import ExpenseImageAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/expense/expense-image/expense-image.entity";
import { CommonModule, DecimalPipe } from "@angular/common";
import { Component, TemplateRef, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import {
  MatSidenavContainer,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router } from "@angular/router";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { IPaginationResult } from "app/common/interfaces/pagination-result.interface";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import {
  ExportDialogComponent,
  ExportOptions,
} from "app/layout/export-overlay";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import {
  EXPENSE_EXPORT_ID,
  EXPENSE_PROPERTIES,
  EXPENSE_TITLE,
} from "app/modules/components/assistant/delivery/loads/exports/reports/expense-report.constants";
import { ExpenseReportExport } from "app/modules/components/assistant/delivery/loads/exports/reports/expense-report.export";
import { BusinessPartnersFiltersComponent } from "app/modules/components/filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "app/modules/components/filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "app/modules/components/filters/dates-filters/dates-filters.component";
import { DocumentsFiltersComponent } from "app/modules/components/filters/documents-filters/documents-filters.component";
import { IFilters } from "app/modules/components/filters/interfaces/filterInterface";
import { MaterialsManagementFiltersComponent } from "app/modules/components/filters/materials-management-filters/materials-management-filters.component";
import { RoutesFiltersComponent } from "app/modules/components/filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "app/modules/components/filters/status-filters/status-filters.component";
import { ExpenseService } from "app/modules/components/payment-master/expense/expense-list/expense-list.service";
import { DocumentFlowButtonComponent } from "app/modules/shared/document-flow-button/document-flow-button.component";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import { UserRouteDisplayComponent } from "app/shared/components/user-route-display/user-route-display.component";
import { DateHelper } from "app/utils/date.helper";
import { getCode } from "app/utils/method";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { debounceTime, distinctUntilChanged, Subscription } from "rxjs";

interface ImageDetail {
  image: {
    link: string;
    alt: string;
  };
  position: number;
}

@Component({
  selector: "app-expense-list",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSidenavModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    FormatOtherDateHourPipe,
    MatAutocompleteModule,
    FilterComponent,
    DecimalFormatPipe,
    DocumentFlowButtonComponent,
    MatMenuModule,
    FilterSectionComponent,
    StatusFiltersComponent,
    MaterialsManagementFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    DocumentsFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    UserRouteDisplayComponent,
    HoverMenuDirective,
    MatTooltipModule,
    CompanyCurrencyPipe,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    DecimalPipe,
    ExpenseReportExport,
  ],
  templateUrl: "./expense-report.component.html",
  styleUrl: "./expense-report.component.scss",
})
export class ExpenseReportComponent {
  getCode = getCode;
  StatusEnum = StatusEnum;
  OrderStatusERPEnum = OrderStatusERPEnum;

  displayedColumns: string[] = [
    "status",
    "statusERP",
    "trip",
    "routeUser",
    "serials",
    "expenseReason",
    "typeDocument",
    "classDocument",
    "amount",
    "creationDateTime",
    "details",
  ];

  dataSource = new MatTableDataSource<ExpenseAttributes>([]);

  totalItems: number = 0;
  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 20;
  pageIndex: number = 1;
  sortActive: keyof ExpenseAttributes = "_id";
  sortDirection: "ASC" | "DESC" = "DESC";

  subs: Subscription[] = [];
  searchSubscription: Subscription;

  formFilters: FormGroup;

  selectedStatuses: number[] = [];

  selectedERPStatuses: number[] = [];

  loadDocumentsData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;

  @ViewChild("commentsModal")
  commentsModal!: TemplateRef<ExpenseReportComponent>;
  dialogRefcomments: MatDialogRef<ExpenseReportComponent>;

  public currentObservation: string | null = null;

  @ViewChild("galleryModal") galleryModal!: TemplateRef<ExpenseReportComponent>;
  dialogRefGallery: MatDialogRef<ExpenseReportComponent>;

  public images: ImageDetail[];
  public currentImages: ExpenseImageAttributes[] = [];
  public currentImageIndex: number = 0;

  /**
   *
   */
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private readonly searchService: SearchService,
    private readonly expenseService: ExpenseService,
    private expenseReportExoport: ExpenseReportExport
  ) {
    const today = new Date();
    this.formFilters = this.fb.group({
      start: [today],
      end: [today],
      subRouteId: [],
      assignedUserId: [],
      searchAssignedUser: [],
      expenseReasonId: [],
      searchExpenseEmision: [],
    });
  }

  onFilterPanelOpened(): void {
    this.loadDocumentsData = true;
    this.loadRoutesData = true;
    this.loadBusinessPartnersData = true;
  }

  ngOnInit(): void {
    this.onHandleSearch();

    this.currentImageIndex = this.images?.length > 0 ? 0 : -1;
  }

  ngAfterViewInit(): void {
    this.onFilter();

    this.searchControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((filterValue: string) => {
        this.pageIndex = 1;
        this.search = filterValue;
        this.onFilter();
      });
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.pageIndex = 1;
        this.search = term;
        this.onFilter();
      }
    );
  }

  onFilter() {
    this.getListReport();
  }

  onClearFilter() {
    this.formFilters.reset();
    this.onFilter();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getListReport();
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction?.toUpperCase() || "ASC";
    this.getListReport();
  }

  changePage(e) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getListReport();
  }

  private getSortField(): keyof ExpenseAttributes {
    const sortFieldMapping: Record<string, keyof ExpenseAttributes> = {
      creationDateTime: "creationDateTime" as keyof ExpenseAttributes,
      amount: "amount" as keyof ExpenseAttributes,
      updatedDateTime: "updatedDateTime" as keyof ExpenseAttributes,
      observation: "observation" as keyof ExpenseAttributes,
      typeDocument: "type.name" as keyof ExpenseAttributes,
      classDocument: "class.name" as keyof ExpenseAttributes,
      trip: "trip.id" as keyof ExpenseAttributes,
      subRoute: "subRoute.name" as keyof ExpenseAttributes,
    };
    return sortFieldMapping[this.sortActive] || "_id";
  }

  getListReport() {
    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.getSortField(),
      sortDirection: this.sortDirection,
    };
    let filter: IFilters = {
      startDate: DateHelper.getStartOfDay(this.formFilters.get("start")?.value),
      endDate:
        DateHelper.getEndOfDay(this.formFilters.get("end")?.value) ??
        DateHelper.getEndOfDay(this.formFilters.get("start")?.value) ??
        null,
      subRouteId: this.formFilters.get("subRouteId")?.value,
      seller: this.formFilters.get("assignedUserId")?.value,
      status: this.selectedStatuses ? this.selectedStatuses : null,
      statusERP: this.selectedERPStatuses.length
        ? this.selectedERPStatuses
        : null,
      expenseReason: this.formFilters.get("expenseReasonId")?.value,
    };

    this.expenseService.findAllWithCount(options, filter).subscribe({
      next: (res: IPaginationResult<ExpenseAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener reporte",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  openNoteDetail(element: ExpenseAttributes) {
    this.currentObservation = element.observation || null;

    if (!this.currentObservation) {
      return;
    }
    this.dialogRefcomments = this.dialog.open(this.commentsModal, {
      width: "550px",
      maxWidth: "95vw",
      disableClose: true,
      panelClass: "custom-dialog-container",
    });
  }

  openGalleryModal(element: ExpenseAttributes): void {
    const images = element.images || [];

    // Validar que haya imágenes antes de abrir
    this.currentImages = images;
    this.currentImageIndex = 0;

    this.dialogRefGallery = this.dialog.open(this.galleryModal, {
      width: "800px",
      maxWidth: "100vw",
      maxHeight: "150vw",
      disableClose: true,
      panelClass: "custom-dialog-container",
    });
  }

  setMainImage(index: number): void {
    this.currentImageIndex = index;
  }

  get currentImageLink(): string | null {
    if (
      this.currentImageIndex >= 0 &&
      this.currentImageIndex < this.currentImages.length
    ) {
      return this.currentImages[this.currentImageIndex].image.link;
    }
    return null;
  }

  onExportButtonPressed() {
    let optionsFilters = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.getSortField(),
      sortDirection: this.sortDirection,
    };
    let filter: IFilters = {
      startDate: DateHelper.getStartOfDay(this.formFilters.get("start")?.value),
      endDate:
        DateHelper.getEndOfDay(this.formFilters.get("end")?.value) ??
        DateHelper.getEndOfDay(this.formFilters.get("start")?.value) ??
        null,
      subRouteId: this.formFilters.get("subRouteId")?.value,
      seller: this.formFilters.get("assignedUserId")?.value,
      status: this.selectedStatuses ? this.selectedStatuses : null,
      statusERP: this.selectedERPStatuses.length
        ? this.selectedERPStatuses
        : null,
      expenseReason: this.formFilters.get("expenseReasonId")?.value,
    };

    if (!this.expenseReportExoport.canStartTask(EXPENSE_EXPORT_ID)) return;

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: EXPENSE_TITLE },
    });

    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.expenseReportExoport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
          EXPENSE_EXPORT_ID,
          EXPENSE_TITLE,
          EXPENSE_PROPERTIES,
          filter,
          optionsFilters
        );
      }
    });
  }

  goToTravel(element: ExpenseAttributes) {
    if (element.trip?.id) {
      const queryParams = { tripId: element.trip.id };
      const urlTree = this.router.createUrlTree(
        ["monitor", "principal-screen"],
        { queryParams }
      );
      const absoluteUrl =
        window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, "_blank");
    }
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
